<mat-card>
  <mat-card-header>
    <mat-card-title>{{fortigate.hostname}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    @if (fortigate.conn_status == 0) {
      <span id="network-health-badge-yellow">
        <mat-icon matTooltip="Health: Unknown" matTooltipPosition="right">network_check</mat-icon>
      </span>
    }
    @if (fortigate.conn_status == 1) {
      <span id="network-health-badge-green">
        <mat-icon matTooltip="Health: good" matTooltipPosition="right">network_check</mat-icon>
      </span>
    }
    @if (fortigate.conn_status == 2) {
      <span id="network-health-badge-red">
        <mat-icon matTooltip="Health: bad" matTooltipPosition="right">network_check</mat-icon>
      </span>
    }
    @if (fortigate.conn_status == 0) {
      <p><b>Status:</b> Unknown</p>
    }
    @if (fortigate.conn_status == 1) {
      <p><b>Status:</b> Online</p>
    }
    @if (fortigate.conn_status == 2) {
      <p><b>Status:</b> Offline</p>
    }
    <p>
      <b matTooltip="The live address on the FortiGate's wan1 interface. This is how the store reaches the internet."
        matTooltipPosition="right">WAN1 IP:</b>
      {{fortigate.wan1_ip || 'Unknown'}}
    </p>
    @if (fortigate.wan2_ip) {
      <p>
        <b matTooltip="The live address on the FortiGate's wan2 backup interface." matTooltipPosition="right">WAN2 IP:</b>
        {{fortigate.wan2_ip}}
      </p>
    }
    <p>
      <b matTooltip="The address FortiManager uses to reach this device. FortiManager sits behind the firewall, so this is a tunnel address, not the store's internet-facing IP."
        matTooltipPosition="right">FortiManager IP:</b>
      {{fortigate.ip}}
    </p>
    <p><b>Serial:</b> {{fortigate.sn}}</p>
    <p><b>ADOM:</b> {{fortigate.adom}}</p>
    <p><b>System Tag:</b> {{fortigate.system_tag}}</p>
    <mat-card id="vpn-1">
      <mat-card-header>
        <mat-card-title>{{fortigate.vpn_status}}</mat-card-title>
        <span id="network-health-badge-green">
        </span>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content>
        <p><b>GBs In/Out:</b>{{fortigate.vpn_incoming_bytes}}<span>/</span>{{fortigate.vpn_outgoing_bytes}}</p>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>